import CropperOriginal, { type CropperClass } from 'react-easy-crop'

/* reexported with a TS type because original module has default export */
export const Cropper: typeof CropperClass =
  CropperOriginal as unknown as typeof CropperClass
